import React from 'react';

export default function TopBanner(){
    return(
        <div className='club-detail-top-banner'>

        </div>
    );

}